/** One Re-Printing Packing Slip: the add page while a draft, read-only once previewed. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { WorkOrderPage } from "@/features/packaging/components/work-order-page";
import { useWorkOrder } from "@/features/packaging/hooks";
import { errMsg } from "@/features/processing/hooks";

export const Route = createFileRoute("/_app/packaging/reprint-slip/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const q = useWorkOrder(Number(id), "reprint");
  const { facilities } = useFacilities();
  if (q.isPending) return <FormPageSkeleton />;
  if (q.isError)
    return (
      <Callout
        tone="danger"
        title="Could not load the re-printing packing slip"
      >
        {errMsg(q.error)}
      </Callout>
    );
  const plant = facilities.find((f) => f.id === q.data.facilityId);
  return (
    <WorkOrderPage
      kind="reprint"
      key={`${q.data.id}-${q.data.status}`}
      order={q.data}
      facilityId={q.data.facilityId}
      plantName={plant ? `${plant.name} (${plant.plantCode})` : null}
    />
  );
}
